import axios from "axios";
import toast from "react-hot-toast";

const instance = axios.create({
  // baseURL: "http://127.0.0.1:8000",
  baseURL: "https://jainvarvadhu.com",
});

const isAuthEndpoint = (url = "") =>
  url.includes("/api/accounts/login/") ||
  url.includes("/api/register/") ||
  url.includes("/api/accounts/register/") ||
  url.includes("/api/token/refresh/") ||
  url.includes("/api/verify-email/");

// Request interceptor to attach access token unless login/register
instance.interceptors.request.use(
  (config) => {
    if (isAuthEndpoint(config.url)) {
      return config;
    }

    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Auth endpoints (login, register, etc.) returning 401 mean "wrong
    // credentials" or "no token to refresh" — not "session expired."
    // Let the calling component's own catch block handle these.
    if (isAuthEndpoint(originalRequest?.url)) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token available");

        // Refresh the access token
        const res = await axios.post(
          "https://jainvarvadhu.com/api/token/refresh/",
          { refresh: refreshToken }
        );
        // const res = await axios.post(
        //   "http://127.0.0.1:8000/api/token/refresh/",
        //   { refresh: refreshToken }
        // );

        const newAccessToken = res.data.access;
        localStorage.setItem("accessToken", newAccessToken);

        // Update Authorization header and retry the original request
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return instance(originalRequest);
      } catch (refreshError) {
        toast.error("Session expired. Please login again.");
        localStorage.clear(); // clear tokens on refresh failure
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;